<template id="app">
	<a-config-provider
		:locale="locale"
		:theme="{
			token: {
				colorPrimary: '#1677ff',
				borderRadius:0,
				fontSize: 14
			}
		}"
	>
	<router-view/>
  </a-config-provider>
</template>

<script setup>
import enUS from 'ant-design-vue/es/locale/en_US';
const locale = enUS;
</script>

<style>
html{
	height: 100%;
}
body{
	height: 100%;
	margin: 0px;
	padding: 0px;
	background-color:#FAFAFA;
	min-width: 420px;
	min-height: 600px;
}

#app{
	padding: 0px;
	height: 100%;
}

.ant-breadcrumb{
	color: rgba(0, 0, 0, 0.8);
	font-weight: 600;
}

#nprogress .bar {
  background: rgb(236, 59, 5) !important;
}

.ant-btn {
    margin-right: 8px !important;
}

.ant-btn-link:hover {
    color: #1677ff !important;
    background-color: #fafafa;
}
.ant-descriptions-view{
	border: 0px !important;
}
.ant-descriptions-row{
	border: 0px !important;
}

.ant-descriptions-item-label {
    border-top: 0px solid red !important;
    border-left: 0px solid red !important;
    border-bottom: 0px solid red !important;
    border-right: 1px solid #f0f0f0 !important;
    text-align: right !important;
    font-weight: bold !important;
    background-color: #FFFFFF !important;
}
.ant-descriptions-item-content {
    border: 0px !important;
}
.ant-table-wrapper .ant-table-tbody >tr.ant-table-row-selected >td{
	background-color: #FFF7D1;
}
.ant-table-wrapper .ant-table-tbody >tr.ant-table-row-selected:hover>td{
	background-color: #FFF7D1;
}

.ant-descriptions.ant-descriptions-bordered .ant-descriptions-view {
    border: 0px !important;
}
.ant-descriptions.ant-descriptions-bordered .ant-descriptions-row {
    border: 0px !important;
}
.ant-table-wrapper tr.ant-table-expanded-row >td, 
.ant-table-wrapper tr.ant-table-expanded-row:hover >td{
    background-color: #FFFFFF !important;
}
.ant-table-wrapper tr.ant-table-expanded-row >td, 
.ant-table-wrapper tr.ant-table-expanded-row:hover >td{
	background-color: #FFFFFF !important;
}

.ant-descriptions.ant-descriptions-bordered .ant-descriptions-row{
	border-bottom: 0px solid red !important;
}
.ant-descriptions.ant-descriptions-bordered .ant-descriptions-view{
	border: 0px solid red !important;
}


.ant-table-body{
	overflow-y: auto !important;
}
.ant-collapse-header{
	padding: 12px 0px !important ;
}

.ant-collapse-item .ant-collapse-content .ant-collapse-content-box{
	padding: 0px 0px 12px 0px !important ;
}

.ant-collapse-header .ant-collapse-header-text{
	font-size: 16px;
	font-weight: bold;
}

.ant-tabs-tab{
	font-weight: bold;
}


.ant-form-inline .ant-form-item {
	margin-bottom: 8px;
}
.ant-btn-primary, .ant-btn-default{
    margin-bottom: 8px;
}

.race-info-table .ant-table-cell .ant-radio-wrapper .ant-radio-inner{
    height: 24px;
    width: 24px;
}

.ant-menu-dark{
	background-color: #000000;
}
</style>
